'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { NavMarker } from 'react-rhumb';
import UIModalPanel from 'UIComponents/dialog/UIModalPanel';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import H2 from 'UIComponents/elements/headings/H2';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIButton from 'UIComponents/button/UIButton';

const FailedEntityManagementPanel = ({
  network,
  entityType,
  onClose
}) => /*#__PURE__*/_jsxs(UIModalPanel, {
  width: 600,
  children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
    children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
      onClick: onClose
    }), /*#__PURE__*/_jsx(H2, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `campaigns.management.header.${network}.${entityType}`
      })
    })]
  }), /*#__PURE__*/_jsx(NavMarker, {
    name: "ENTITY_MANAGEMENT_PANEL_FAILURE",
    children: /*#__PURE__*/_jsx(UIDialogBody, {
      children: /*#__PURE__*/_jsx(UIErrorMessage, {
        type: "500",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "errors.genericError"
        })
      })
    })
  }), /*#__PURE__*/_jsxs(UIDialogFooter, {
    children: [/*#__PURE__*/_jsx(UIButton, {
      use: "primary",
      disabled: true,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "saveButton"
      })
    }), /*#__PURE__*/_jsx(UIButton, {
      use: "secondary",
      onClick: onClose,
      "data-test-id": "cancel-button",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "cancelButton"
      })
    })]
  })]
});

export default FailedEntityManagementPanel;